import { Checkbox, Grid, Icon, Popup } from "semantic-ui-react";
import React, { useCallback, useState } from "react";
import { UseFormEvent } from "../../../custom-hooks/form/useForm";

type HighlyAvailableControlPlaneProps = {
  handleChange: (event: UseFormEvent | Array<UseFormEvent>) => void;
  disabled: boolean;
  checked: boolean;
  isRunningOperation: boolean;
};

export default function HighlyAvailableControlPlane({
  handleChange,
  disabled,
  checked,
  isRunningOperation = false,
}: HighlyAvailableControlPlaneProps) {
  const [isChecked, setIsChecked] = useState(checked);

  const handleOnChange = useCallback(() => {
    handleChange({ name: "enableHaControlPlane", value: !isChecked });
    setIsChecked((state) => !state);
  }, [handleChange, isChecked]);

  return (
    <Grid.Row className={"separator"}>
      <Grid.Column
        textAlign="left"
        width={16}
        className="flex vcenter margin-bottom-20 color-gray-100"
      >
        <Checkbox
          toggle
          name="failureToleranceType"
          checked={isChecked}
          label={"Enable Highly Available Control Plane"}
          onChange={handleOnChange}
          disabled={disabled}
        />
        <Popup
          trigger={
            <Icon
              name="exclamation circle"
              className="margin-left"
              style={{ marginTop: "6px" }}
              color="grey"
            />
          }
          content={
            <div>
              Enable Highly Available Control Plane for Shoot
              <br />
              <br />
              When enabled in regions that support{" "}
              <span className="color-orange">
                Three or more Availability Zones
              </span>
              , Control Plane components will be replicated across all
              Availability Zones. This ensures that in case of an Availability
              Zone outage, the Control Plane for the cluster remains available.
              <br />
              <br />
              In Regions that support only{" "}
              <span className="color-orange">Single Availability Zone</span>,
              Control Plane components will be replicated accross multiple Nodes
              to prevent any outages.
              <br />
              <br />
              This option acts independently from Availability Zones selected
              for Worker Groups, allowing you to choose any number of
              Availability Zones for Worker Groups.
              <br />
            </div>
          }
        />
      </Grid.Column>
      {isChecked && (
        <Grid.Column width={16}>
          <div className={"padding-20 margin-top-15 bg-light-grey"}>
            This action is irreversible. Once High Availability Control Plane is
            enabled, you won't be able to disable it.
          </div>
        </Grid.Column>
      )}
      {isRunningOperation && (
        <Grid.Column width={16}>
          <div className={"padding-20 margin-top-15 bg-light-grey"}>
            Note: Shoot is currently running an operation. Please wait until it
            finishes.
          </div>
        </Grid.Column>
      )}
    </Grid.Row>
  );
}
